export default [
  {
    path: '/sortExamine',
    name: 'sortExamine',
    meta: {
      title: '分类自检审核'
    },
    component: () =>
      import(/* webpackChunkName: "addlifeRubbishGoods" */ '@/views/sortExamine/index.vue')
  }
]
